

















































































































































import { Geek, Theme } from '@/models';
import { typedStore } from '@/store';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import { RouteRecord } from 'vue-router';

export default Vue.extend({
  name: 'Nav',
  props: {
    geek: Object as () => Geek,
  },
  computed: {
    isCurrentGeekProfileId(): boolean {
      if (!this.$route.path.startsWith('/geek-profile')) {
        return false;
      }

      return typedStore(this).state.geek.current.id === this.$route.params.geekId;
    },
    currentTheme(): Theme {
      return this.$store.state.themes.current;
    },
  },
});
